import React from "react";

import NoImage from "assets/img/NoImage.png";
import { ImageWrapper } from "./Image.styles";

export const Image = React.memo(({ src, alt, ...rest }) => (
  <ImageWrapper {...rest}>
    <img src={src || NoImage} alt={alt} width="100%" height="100%" />
  </ImageWrapper>
));
